module.exports = __webpack_public_path__ + "static/media/shego-win.f2dd17cf.png";